import React from 'react';
import PropTypes from 'prop-types';

import Numeral, { NumeralTypes } from '../shared/numeral.component';
import CustomNumeral from '../shared/customNumeral.component';

const propTypes = {
  value: PropTypes.number,
};

const DecimalRenderer = ({ value }) => (!value && value !== 0) ? null : (
  <Numeral type={NumeralTypes.DECIMAL}>{value}</Numeral>
);

DecimalRenderer.propTypes = propTypes;

const NumberRenderer = ({ value }) => (!value && value !== 0) ? null : (
  <Numeral type={NumeralTypes.NUMBER}>{value}</Numeral>
);

NumberRenderer.propTypes = propTypes;

const CustomRenderer = ({ value }) => (
  <CustomNumeral type={NumeralTypes.NUMBER}>{value}</CustomNumeral>
);

CustomRenderer.propTypes = propTypes;

const CustomDecimalRenderer = ({ value }) => (
  <CustomNumeral type={NumeralTypes.DECIMAL}>{value}</CustomNumeral>
);

CustomDecimalRenderer.propTypes = propTypes;

const CustomRendererWithoutNull = ({ value }) => (!value && value !== 0)
  ? null
  : (<CustomNumeral type={NumeralTypes.DECIMAL}>{value}</CustomNumeral>);

CustomRendererWithoutNull.propTypes = propTypes;

export { DecimalRenderer, NumberRenderer, CustomRenderer, CustomDecimalRenderer, CustomRendererWithoutNull };
